import {FinancialSource, Status} from "../enums/enums";

export const transactionTypeSchema = () => {
    return (
        {
            name: {
                type: 'text',
                label: 'Name',
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value.trim() === '') return 'Name is required';
                    return null;
                },
            },
            source: {
                type: 'select',
                label: 'Source',
                enums: true,
                options: FinancialSource,
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    if (value === '') return 'Source is required';
                    return null;
                },
            },
            status: {
                type: 'select',
                label: 'Status',
                enums: true,
                options: Status,
                columns: {md: 12, lg: 6},
                validation: (value) => {
                    return null;
                },
            },
            description: {
                type: 'textarea',
                label: 'Description',
            }
        }
    )
}
